export function consumeOAuthError(): string|undefined {
  const url = new URL(window.location.href);
  const error = url.searchParams.get('oauth_error') ?? undefined;
  if (!error)
    return undefined;
  url.searchParams.delete('oauth_error');
  window.history.replaceState(window.history.state, '', url);
  return error;
}
